module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q8SQWX.00e9d65d.jpg";